
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';



@Component({
  selector: 'lista-categorias',
  templateUrl: './lista-categorias.component.html',
  styleUrls: ['./lista-categorias.component.css']
})
export class ListaCategoriasComponent {

  constructor(
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
  ) { }

  categorias: string[];

  ngOnInit(): void {
    this.afs.collection('global').doc('global').ref.get().then(doc => {
      const global = doc.data();
      this.categorias = global['categoria']
      console.log(this.categorias)
    });
  }

}
